export default __webpack_public_path__ + "static/media/logo.721ea71e.png";